import React, { useState, useEffect } from "react";
import ExtensionCard, { ExtensionCardHeader } from "app/popleads/components/ui-kit/ExtensionCard";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import useTaskUpdate from "app/popleads/hooks/useTaskUpdate";
import useGetTaskLists from "app/popleads/hooks/useGetTaskLists";
//import useTaskImportant from "app/popleads/hooks/useTaskImportant";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { StyledTaskListContent, StyledTaskListHeader, TaskColorIcon } from "./common/styled";
import moment from "moment";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import EmptyStatus from "./common/EmptyStatus";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "app/popleads/components/ui-kit/DateInput";
import { toast } from "react-toastify";
import useTaskComplete from "app/popleads/hooks/useTaskComplete";
import { Heading6 } from "app/popleads/components/ui-kit/Text";
import { useSelector } from "react-redux";
import ExpandingBox from "app/popleads/components/ui-kit/ExpandingBox";
import highlightFromTo from "app/popleads/modules/extension/utils/highlightFromTo";
import FeatherIcon from "feather-icons-react";
import useTaskImportant from "app/popleads/hooks/useTaskImportant";

const ActionBar = styled.div`
    display: flex;
    align-items: center;
    background-color: ${colors.neutral[100]};
    flex-direction: column;
    border-radius: 0px 0px 6px 6px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-width: 0 1px 1px 1px;
    border-style: solid;
    border-color: ${colors.neutral[100]};
`;

const ActionButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 0px;
    padding: 0 4px;
    width: 100%;
`;

const CreatedInfoBar = styled.div`
    background-color: #fff;
    padding: 8px 12px;
    width: 100%;
    border-bottom: 1px solid ${colors.neutral[100]};
    font-size: 12px;
    color: ${colors.neutral[600]};
`;

const StyledCardContainer = styled.div`
    div {
        margin-bottom: 0 !important; /* Remove any bottom margin */
        &:hover {
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }
`;
const StyledCollapseIcon = styled.div`
    cursor: pointer;
    color: ${colors.neutral[600]};
`;
const MoveDropdown = styled.div`
    position: absolute;
    background: ${colors.white};
    border: 1px solid ${colors.neutral[100]};
    border-radius: 6px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    bottom: calc(100%);
    left: 50%;
    transform: translateX(-50%);
    display: none;
    min-width: 120px;
    z-index: 10;

    &:after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 16px;
        background: transparent;
    }

    &:before {
        content: "";
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 12px;
        height: 12px;
        background: ${colors.white};
        border-right: 1px solid ${colors.neutral[100]};
        border-bottom: 1px solid ${colors.neutral[100]};
    }
`;

const MoveOption = styled.div`
    padding: 8px 16px;
    color: ${colors.neutral[800]};
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background: ${colors.neutral[50]};
    }
`;

const MoveButtonWrapper = styled.div`
    position: relative;
    //padding: 4px 0;

    &:hover ${MoveDropdown} {
        display: block;
    }

    ${MoveDropdown}:hover {
        display: block;
    }
`;

const DatePickerWrapper = styled.div`
    position: absolute;
    bottom: calc(100% + 8px);
    left: 100%;
    transform: translateX(-50%);
    z-index: 10;
    background: ${colors.white};
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(73, 105, 140, 0.1);
`;

const ViewMoreButton = styled(Heading6)`
    color: ${colors.l3rnTech[900]};
    cursor: pointer;
    display: block;
    margin: 0;
    padding: 0;
    text-align: left;
    border: none;
    background: none;
`;

const TaskCardWrapper = styled.div`
    position: relative;

    .task-header {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;
        padding: 0;
    }

    &:hover .task-header {
        max-height: 100px;
    }
`;

const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: ${colors.l3rnTech[900]};
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    display: block;
    text-align: left;
    padding: 0;
`;

const ExpandableBox = styled.div`
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ isExpandedShowMore }) => (isExpandedShowMore ? "unset" : 2)};
`;

const StyledNoteContent = styled.div`
    color: ${({ variant }) => (variant === "warning" ? colors?.warning[800] : colors.neutral[800])};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.17px;
    line-height: 21px;
    overflow-wrap: anywhere;
    ${({ variant }) => variant === "notEdit" && "cursor: pointer;"}
    & > p {
        margin: 0;
    }

    & i {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        line-height: inherit;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
`;

const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        font-size: 11px !important;
    }
`;

const ImportantBadge = styled.div`
    width: 19px;
    height: 19px;
    background-color: ${(props) => (props.important ? colors.danger[900] : colors.neutral[300])};
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: -3px;
    z-index: 10;
    border: 2px solid ${colors.white};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    color: ${colors.white};
    line-height: 1;

    &:hover {
        background-color: ${(props) => (props.important ? colors.danger[600] : colors.neutral[400])};
        transform: scale(1.1);
    }
`;

const ExtensionTaskCard = ({ setTaskToDelete }) => {
    const { collapsedCards, setCollapsedCard, getTaskListLoading, taskRef, ...ctx } = useExtensionContext();
    const { updateTask } = useTaskUpdate();
    const { refetch: fetchTaskLists } = useGetTaskLists();
    const { completeTask } = useTaskComplete();
    //const { toggleTaskImportant } = useTaskImportant();
    const [selectedTask, setSelectedTask] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [taskStates, setTaskStates] = useState({});
    const { toggleTaskImportant } = useTaskImportant();

    const { user } = useSelector((state) => state.auth);

    const collapsed = collapsedCards.task;
    const handleCollapseChange = (val) => {
        setCollapsedCard("task", val);
    };

    useEffect(() => {
        const tasks = ctx.profile?.gorev || [];
        setTaskStates((prev) => {
            const newTaskStates = { ...prev };
            let hasChanges = false;

            tasks.forEach((task) => {
                if (!newTaskStates[task.id]) {
                    newTaskStates[task.id] = {
                        isExpandedShowMore: false,
                        isOverflowing: false,
                    };
                    hasChanges = true;
                }
            });

            Object.keys(newTaskStates).forEach((taskId) => {
                if (!tasks.find((task) => task.id === taskId)) {
                    delete newTaskStates[taskId];
                    hasChanges = true;
                }
            });

            return hasChanges ? newTaskStates : prev;
        });
    }, [ctx.profile?.gorev]);

    useEffect(() => {
        const checkOverflow = () => {
            const tasks = ctx.profile?.gorev || [];
            tasks.forEach((task) => {
                const el = document.querySelector(`[data-task-content="${task.id}"]`);
                if (el) {
                    const isClamped = el.scrollHeight > el.clientHeight;
                    setTaskStates((prev) => {
                        if (prev[task.id]?.isOverflowing !== isClamped) {
                            return {
                                ...prev,
                                [task.id]: {
                                    ...prev[task.id],
                                    isOverflowing: isClamped,
                                },
                            };
                        }
                        return prev;
                    });
                }
            });
        };

        const timeoutId = setTimeout(checkOverflow, 100);
        return () => clearTimeout(timeoutId);
    }, [ctx.profile?.gorev]);

    const toggleShowMore = (taskId) => {
        setTaskStates((prev) => ({
            ...prev,
            [taskId]: {
                ...prev[taskId],
                isExpandedShowMore: !prev[taskId]?.isExpandedShowMore,
            },
        }));
    };

    const hasTaskPermission = (task) => {
        if (task.kullaniciId) {
            return task.kullaniciId && task.kullaniciId === user?.id;
        }
        return true;
    };

    const handleNoPermission = () => {
        toast.error("You do not have permission to edit this task");
    };

    const handleTaskDeleteClick = (task) => {
        if (!hasTaskPermission(task)) {
            handleNoPermission();
            return;
        }

        ctx.setState({
            selectedModal: ctx.modals.DELETE_TASK,
            modalMessage:
                !!task.assignedById && user?.id !== task.assignedById
                    ? "This task has been assigned to you by other user. Are you sure you want to delete it?"
                    : "Are you sure you want to delete this task?",
        });
        setTaskToDelete(task.id);
    };

    const handleTaskClick = (zaman, id, gorev) => {
        if (user?.name !== gorev.kayitci) {
            toast.error("You are not the owner of the task!");
            return;
        }

        ctx.setState({
            selectedTab: "Tasks",
            selectedDate: new Date(zaman),
            selectedTasksId: id,
            popupContent: null,
            popupIsOpen: false,
        });
    };

    const handleDateChange = (date) => {
        if (selectedTask && date) {
            // Convert date to days difference for the move function
            const selectedDate = new Date(date);
            const currentDate = new Date(selectedTask.zaman);
            const timeDiff = selectedDate.getTime() - currentDate.getTime();
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

            handleMove(selectedTask.id, selectedTask.metin, selectedTask.zaman, selectedTask.profileId, daysDiff);
            setShowDatePicker(false);
            setSelectedTask(null);
        }
    };

    const handleOtherClick = (task) => {
        setSelectedTask(task);
        setShowDatePicker(true);
    };

    const moveOptions = [
        { label: "+7 days", value: 7 },
        { label: "+3 days", value: 3 },
        { label: "+1 day", value: 1 },
        { label: "Other", value: "other" },
    ];

    const handleMove = async (taskId, title, zaman, profileId, days) => {
        const task = ctx.profile?.gorev?.find((g) => g.id === taskId);
        if (task && !hasTaskPermission(task)) {
            handleNoPermission();
            return;
        }

        try {
            // Check if task is overdue
            const isOverdue = moment(zaman).isBefore(moment(), "day");
            let newDate;

            if (isOverdue) {
                // For overdue tasks: today + days, preserving original time
                const originalTime = moment(zaman);
                const today = moment().startOf("day");
                newDate = today
                    .add(days, "days")
                    .hour(originalTime.hour())
                    .minute(originalTime.minute())
                    .second(originalTime.second())
                    .valueOf();

                // Update with exact date (not using daysToAdd)
                await updateTask({
                    taskId: taskId,
                    taskText: title,
                    currentDate: newDate,
                    profileId,
                    daysToAdd: 0,
                    important: task.important,
                });
            } else {
                // For future tasks: use daysToAdd to add to current date
                await updateTask({
                    taskId: taskId,
                    taskText: title,
                    currentDate: zaman,
                    profileId,
                    daysToAdd: days,
                    important: task.important,
                });
            }

            toast.success(`Task moved by ${days} day${days > 1 ? "s" : ""}`);
            fetchTaskLists();
            //ctx.refetchProfile();
            ctx.refetchTaskList();
        } catch (error) {}
    };

    const handleTaskComplete = async (taskId) => {
        try {
            const response = await completeTask(taskId);
            if (response?.stat === "ok") {
                //ctx.refetchProfile();
                ctx.refetchTaskList();
                fetchTaskLists();
                toast.success("Task completed");
                const messagePayload = {
                    message: "XPIDER_MESSAGE_NOTIFICATION",
                    task: {
                        id: taskId,
                        status: "completed",
                    },
                };
                window.parent.postMessage(messagePayload, "*");
            } else {
                toast.error(response?.text || "Failed to complete task.");
            }
        } catch (error) {
            toast.error(error || "Oops! Something went wrong.");
        }
    };

    const handleImportantToggle = async (taskId, currentImportant) => {
        const task = ctx.profile?.gorev?.find((g) => g.id === taskId);
        if (task && !hasTaskPermission(task)) {
            handleNoPermission();
            return;
        }

        const isEditingThisTask = ctx.editMode && ctx.selectedTask && ctx.selectedTask.id === taskId;

        if (isEditingThisTask) {
            toast.error("You can't change importance while editing this task.");
            return;
        }

        try {
            const response = await toggleTaskImportant(taskId, currentImportant);
            if (response?.data?.stat === "ok") {
                //ctx.refetchProfile();
                ctx.refetchTaskList();
                fetchTaskLists();
                toast.success(currentImportant ? "Task marked as normal" : "Task marked as important");
            } else {
                throw new Error("Failed to update task importance");
            }
        } catch (error) {
            toast.error("Failed to update task importance");
        }
    };

    const renderTask = (gorev) => {
        const isEditingThisTask = ctx.editMode && ctx.selectedTask && ctx.selectedTask.id === gorev.id;
        const taskState = taskStates[gorev.id] || { isExpandedShowMore: false, isOverflowing: false };

        const task = {
            id: gorev.id,
            header: (
                <StyledTaskListHeader className="task-header">
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <OverlayTrigger placement="top" overlay={<StyledTooltip>Tasks Date & Time</StyledTooltip>}>
                            <span>{moment(gorev.zaman).format("MMM DD, YYYY - hh:mm A")}</span>
                        </OverlayTrigger>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {gorev.taskColour && <TaskColorIcon color={gorev.taskColour} />}
                        {gorev.type}
                    </div>
                </StyledTaskListHeader>
            ),
            content: (
                <StyledTaskListContent>
                    <ContentWrapper>
                        <ExpandableBox data-task-content={gorev.id} isExpandedShowMore={taskState.isExpandedShowMore}>
                            <StyledNoteContent
                                variant={"notEdit"}
                                dangerouslySetInnerHTML={{
                                    __html: highlightFromTo(gorev.metin),
                                }}
                            />
                        </ExpandableBox>
                    </ContentWrapper>
                    {taskState.isOverflowing && (
                        <ShowMoreButton
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleShowMore(gorev.id);
                            }}
                        >
                            {taskState.isExpandedShowMore ? "Show Less" : "Show More"}
                        </ShowMoreButton>
                    )}
                </StyledTaskListContent>
            ),
        };

        const hasPermission = hasTaskPermission(gorev);

        const actionButtons = [
            {
                variant: "success",
                onClick: () => {
                    if (!hasPermission) {
                        handleNoPermission();
                        return;
                    }
                    if (isEditingThisTask) {
                        toast.error("You can't complete this task while editing.");
                        return;
                    }
                    handleTaskComplete(gorev.id);
                },
                text: "Complete",
            },
            {
                variant: "passive",
                component: (
                    <MoveButtonWrapper key="move-button">
                        <ButtonWithText
                            variant="passive"
                            buttonStyle="borderless"
                            size="xsmall"
                            style={{ margin: "0px", padding: "0px" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!hasPermission) {
                                    handleNoPermission();
                                    return;
                                }
                                if (isEditingThisTask) {
                                    toast.error("You can't move this task while editing.");
                                    return;
                                }
                            }}
                        >
                            Move
                        </ButtonWithText>
                        {!isEditingThisTask && (
                            <>
                                <MoveDropdown>
                                    {moveOptions.map((option) => (
                                        <MoveOption
                                            key={option.value}
                                            onClick={() =>
                                                option.value === "other"
                                                    ? handleOtherClick(gorev)
                                                    : handleMove(
                                                          gorev.id,
                                                          gorev.metin,
                                                          gorev.zaman,
                                                          gorev.profileId,
                                                          option.value
                                                      )
                                            }
                                        >
                                            {option.label}
                                        </MoveOption>
                                    ))}
                                </MoveDropdown>
                                {showDatePicker && selectedTask?.id === gorev.id && (
                                    <DatePickerWrapper>
                                        <CustomDatePicker
                                            componentVariant="l3rnTech"
                                            variant="move-dropdown"
                                            onChange={handleDateChange}
                                            onClickOutside={() => {
                                                setShowDatePicker(false);
                                                setSelectedTask(null);
                                            }}
                                            showMonthYearDropdown={true}
                                        />
                                    </DatePickerWrapper>
                                )}
                            </>
                        )}
                    </MoveButtonWrapper>
                ),
            },
            {
                variant: "danger",
                onClick: () => {
                    if (hasPermission) {
                        if (isEditingThisTask) {
                            toast.error("You can't delete this task while editing.");
                            return;
                        }
                        handleTaskDeleteClick(gorev);
                    } else {
                        handleNoPermission();
                    }
                },
                text: "Delete",
            },
            {
                variant: "l3rnTech",
                onClick: () => {
                    if (!hasPermission) {
                        handleNoPermission();
                        return;
                    }

                    ctx.setState({
                        popupContent: POPUP_CONTENTS.NEW_TASK,
                        popupIsOpen: true,
                        taskPage: true,
                        selectedTask: gorev,
                        editMode: true,
                    });
                },
                text: "Edit",
            },
        ];

        return (
            <TaskCardWrapper>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <StyledTooltip id="tooltip-important">
                            {gorev.important === 1 ? "Click to mark as normal" : "Click to mark as important"}
                        </StyledTooltip>
                    }
                >
                    <ImportantBadge
                        important={gorev.important === 1}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleImportantToggle(gorev.id, gorev.important);
                        }}
                    >
                        !
                    </ImportantBadge>
                </OverlayTrigger>
                <ExpandingBox
                    key={gorev.id}
                    footerHeight="70px"
                    footer={
                        <ActionBar>
                            <CreatedInfoBar
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    //marginBottom: "-5px",
                                }}
                            >
                                <OverlayTrigger placement="top" overlay={<StyledTooltip>Created Date</StyledTooltip>}>
                                    <span>Created on {moment(gorev.createdTime).format("MMM DD, YYYY hh:mm A")}</span>
                                </OverlayTrigger>{" "}
                                {gorev.kayitci && `- ${gorev.kayitci}`}
                            </CreatedInfoBar>
                            <ActionButtonsWrapper>
                                {actionButtons.map((button) =>
                                    button.component ? (
                                        button.component
                                    ) : (
                                        <ButtonWithText
                                            key={button.text}
                                            size="xsmall"
                                            variant={button.variant}
                                            buttonStyle="borderless"
                                            onClick={button.onClick}
                                            style={{ margin: "0px", padding: "0px" }}
                                        >
                                            {button.text}
                                        </ButtonWithText>
                                    )
                                )}
                            </ActionButtonsWrapper>
                        </ActionBar>
                    }
                >
                    <StyledCardContainer
                        onClick={() => handleTaskClick(gorev.zaman, gorev.id, gorev)}
                        style={{ cursor: "pointer", marginBottom: 0 }}
                    >
                        <ExtensionCard cardItems={[task]} viewMore={false} iconWidth="0px" />
                    </StyledCardContainer>
                </ExpandingBox>
            </TaskCardWrapper>
        );
    };
    const tasks = ctx.profile?.gorev || [];
    const today = new Date();
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const sortedTasks = [...tasks].sort((a, b) => {
        const dateA = new Date(a.zaman);
        const dateB = new Date(b.zaman);

        const dateAOnly = new Date(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
        const dateBOnly = new Date(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());

        const diffA = Math.abs(dateAOnly - todayOnly);
        const diffB = Math.abs(dateBOnly - todayOnly);

        return diffA - diffB;
    });
    const displayTasks = sortedTasks.slice(0, 3);
    const hasMoreTasks = tasks.length > 3;

    const handleTasksOpen = () => {
        if (ctx.popit) {
            toast.warning("You need to POP the profile first.");
        } else {
            ctx.setState({ popupContent: POPUP_CONTENTS.PROFILE_TASKS, popupIsOpen: true });
        }
    };

    return (
        <div ref={taskRef} style={{ padding: "12px 0px", borderBottom: "1px solid rgb(225, 225, 225)" }}>
            <span className="d-flex">
                <div className="mr-2" onClick={() => handleCollapseChange(!collapsed)}>
                    {collapsed ? (
                        <StyledCollapseIcon>
                            <FeatherIcon icon="chevron-down" size={17} />
                        </StyledCollapseIcon>
                    ) : (
                        <StyledCollapseIcon>
                            <FeatherIcon icon="chevron-up" size={17} />
                        </StyledCollapseIcon>
                    )}
                </div>
                <ExtensionCardHeader
                    cardTitle={"Tasks"}
                    content="tasks"
                    cardTitleOnClick={handleTasksOpen}
                    button={
                        <ButtonWithText
                            icon="add"
                            iconType="material"
                            variant="l3rnTech"
                            buttonStyle="default"
                            size="circle"
                            onClick={() => {
                                if (ctx.popit) {
                                    toast.warning("You need to POP the profile first.");
                                } else {
                                    ctx.setState({
                                        popupContent: POPUP_CONTENTS.NEW_TASK,
                                        popupIsOpen: true,
                                        taskPage: false,
                                        editMode: false,
                                    });
                                }
                            }}
                        />
                    }
                />
            </span>
            {getTaskListLoading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        padding: "12px",
                    }}
                >
                    <Spinner animation="border" variant="l3rnTech" />
                </div>
            ) : (
                !collapsed && (
                    <div style={{ marginTop: "10px" }}>
                        {displayTasks.length > 0 ? (
                            displayTasks.map(renderTask)
                        ) : (
                            <EmptyStatus description="Click the + to create a new task." />
                        )}

                        {hasMoreTasks && (
                            <div style={{ paddingTop: "8px", paddingBottom: "4px" }}>
                                <ViewMoreButton onClick={handleTasksOpen}>View More</ViewMoreButton>
                            </div>
                        )}
                    </div>
                )
            )}
        </div>
    );
};

export default ExtensionTaskCard;
